import { render, staticRenderFns } from "./CustomerServiceConfig.vue?vue&type=template&id=7858ccea&scoped=true"
import script from "./CustomerServiceConfig.vue?vue&type=script&lang=js"
export * from "./CustomerServiceConfig.vue?vue&type=script&lang=js"
import style0 from "./CustomerServiceConfig.vue?vue&type=style&index=0&id=7858ccea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7858ccea",
  null
  
)

export default component.exports